import styled from 'styled-components'

export const PreviewContainer = styled.div`
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  margin: 20px auto;
  max-width:700px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`

export const Heading = styled.h2`
  margin-bottom: 10px;
`

export const Paragraph = styled.p`
  line-height: 1.6;
  font-size: 16px;
`
